import React, {memo} from "react";
import imgLoader from "../../../../images/icon-loader.png";
const LoaderModals = () => {
    return (
        <div className="loader-loading">
            <div>
                <img src={imgLoader} alt="logo Site"/>
                <span>لطفا منتظر بمانید...</span>
            </div>
        </div>
    )
};

export default memo(LoaderModals);
